import styled from "styled-components";
import {
  blackColor,
  darkColor,
  orangeColor,
  purpleColor,
  whiteColor,
} from "../../constants/colors";
import arrowIcon from "./../../resources/images/icons/arrow_icon.svg";
import { PAYWALL_FIRST, PAYWALL_FOURTH } from "../../constants/data";

const SubscriptionBlock = styled.div`
  padding-top: 53px;
  overflow-x: hidden;
  position: relative;
  background: ${(props) =>
    props.paywallState === PAYWALL_FIRST ||
    props.paywallState === PAYWALL_FOURTH
      ? "#E0DFF0"
      : null};
  .blue {
    position: absolute;
    top: 0;
    left: 0;
  }
  .purple {
    position: absolute;
    top: 300px;
    right: 0;
  }
`;

SubscriptionBlock.Time = styled.div`
  padding: 20px 23px;
  background: #fcf5fa;
  border-radius: 12px;
  margin-bottom: 44px;
  border: 1px solid #aba6d6;
`;

SubscriptionBlock.Top = styled.div``;

SubscriptionBlock.Chart = styled.div`
  margin-bottom: 44px;
`;
SubscriptionBlock.Chart.Img = styled.div`
  width: 100%;
  margin-bottom: 9px;
  margin-left: -5px;
  margin-right: -5px;
  img {
    width: 103%;
  }
`;
SubscriptionBlock.List = styled.div``;
SubscriptionBlock.List.Items = styled.div``;
SubscriptionBlock.List.Item = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 17px;
`;
SubscriptionBlock.List.Item.Img = styled.div`
  min-width: 63px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
SubscriptionBlock.List.Item.Text = styled.div`
  text-align: left;
`;

SubscriptionBlock.Cost = styled.div`
  margin-bottom: 58px;
`;

SubscriptionBlock.Cost.Trial = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;
  border-top: 1px solid #cac5c2;
  border-bottom: 1px solid #cac5c2;
  margin-bottom: 19px;
`;

SubscriptionBlock.Cost.After = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 18px;
  padding-bottom: 18px;
  border-top: 1px solid #cac5c2;
  border-bottom: 1px solid #cac5c2;
  margin-bottom: 20px;
`;

SubscriptionBlock.Cost.After.Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:first-child {
    margin-bottom: 18px;
  }
`;

SubscriptionBlock.Cost.After.Bg = styled.div`
  background: linear-gradient(260.48deg, #ff9960 -18.28%, #e76218 117.8%);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 35px;
`;

SubscriptionBlock.Guarantee = styled.div`
  background: ${(props) => (props.paywall === 3 ? "#FDF6F9" : "#efefef")};
  border-radius: 12px;
  padding: 20px 30px 20px 34px;
  position: relative;
  margin-bottom: 12px;
  border: ${(props) => (props.paywall === 3 ? "1px solid #ABA6D6" : "none")};
  p {
    opacity: 0.7;
  }
  ul {
    padding-left: 20px;
    margin: 0;
  }
  li {
    font-family: SF, sans-serif;
    text-align: left;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: ${blackColor};
    opacity: 0.7;
    &:first-child {
      margin-bottom: 8px;
    }
  }
  img {
    position: absolute;
    bottom: 72px;
    right: 15px;
  }
`;

SubscriptionBlock.Comments = styled.div`
  border-top: 1px solid #cac5c2;
  border-bottom: 1px solid #cac5c2;
  padding-top: 37px;
  padding-bottom: 51px;
`;

SubscriptionBlock.Comments.Item = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 36px;
  &:last-child {
    margin-bottom: 0;
  }
`;
SubscriptionBlock.Comments.Top = styled.div`
  display: flex;
  margin-bottom: 12px;
`;
SubscriptionBlock.Comments.Top.Left = styled.div`
  width: 48px;
  height: 48px;
  margin-right: 12px;
  img {
    width: 100%;
  }
`;
SubscriptionBlock.Comments.Top.Right = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;
SubscriptionBlock.Comments.Top.Right.Top = styled.div`
  margin-bottom: 6px;
`;
SubscriptionBlock.Comments.Top.Right.Bottom = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 17px;
  }
`;
SubscriptionBlock.Comments.Bottom = styled.div``;

SubscriptionBlock.Bottom = styled.div`
  padding-top: 44px;
  padding-bottom: 50px;
`;

SubscriptionBlock.Bottom.New = styled.div`
  padding-top: 35px;
  padding-bottom: 11px;
  background: ${whiteColor};
`;

SubscriptionBlock.Bottom.Separator = styled.div`
  padding: 32px 0 11px;
  
  .line {
    height: 1px;
    background-color: rgb(202, 197, 194);
    margin-bottom: 29px;
  }
`

SubscriptionBlock.Footer = styled.div`
  padding-bottom: 45px;
`;

SubscriptionBlock.Footer.New = styled.div`
  padding-bottom: 45px;
  padding-top: 43px;
`;

SubscriptionBlock.Footer.Top = styled.div`
  display: flex;
  margin-bottom: 46px;
`;
SubscriptionBlock.Footer.Top.Item = styled.div`
  flex-grow: 1;
`;
SubscriptionBlock.Footer.Bottom = styled.div``;

SubscriptionBlock.Form = styled.div``;
SubscriptionBlock.Fixed = styled.div`
  position: fixed;
  padding-left: 15px;
  padding-right: 15px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 125px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 20px;
  box-sizing: border-box;
  background: linear-gradient(
    179.8deg,
    rgba(255, 255, 255, 0) 0.18%,
    #ffffff 49.73%
  );
  z-index: 0;
  opacity: 0;
  transition: 0.3s;
  &.button-visible {
    opacity: 1;
    z-index: 2;
  }
`;

const TimeBlock = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fcf5fa;
  z-index: 2;
  transform: translateY(-100%);
  transition: 0.3s ease-in-out;
  &.visible {
    transform: translateY(0);
  }
`;

const PaymentBlock = styled.div`
  padding-top: 0px;
  padding-bottom: 25px;
  border-bottom: 1px solid #cac5c2;
  background: ${whiteColor};
  .StripeElement--webkit-autofill {
    background-color: transparent !important;
  }
`;

PaymentBlock.Back = styled.div`
  width: 50px;
  margin-bottom: 45px;
`;

PaymentBlock.Prebottom = styled.div`
  border-top: 1px solid #cac5c2;
  padding-top: 29px;
`;

PaymentBlock.Top = styled.div`
  padding-bottom: 10px;
  border-bottom: 1px solid #cac5c2;
`;
PaymentBlock.Top.Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
PaymentBlock.Top.Method = styled.div`
  width: 100%;
  height: 57px;
  background: #dcdcdc;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 44px;
`;

PaymentBlock.Form = styled.div`
  padding-top: 11px;
`;
PaymentBlock.Form.Top = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #6c6c6c;
  font-size: 12px;
  line-height: 13.2px;
  font-weight: 400;
  span {
    padding-top: 5px;
  }
`;

PaymentBlock.Form.Inputs = styled.div`
  padding-top: 11px;
  padding-bottom: 11px;
`;

PaymentBlock.Form.Info = styled.div``;

PaymentBlock.Form.Apple = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 33px;
`;
PaymentBlock.Form.Apple.Left = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 35px;
`;
PaymentBlock.Form.Apple.Left.Top = styled.div`
  margin-bottom: 10px;
  img {
    width: 56px;
    height: auto;
  }
`;
PaymentBlock.Form.Apple.Left.Bottom = styled.div`
  display: flex;
  justify-content: center;
  p {
    color: #6c6c6c;
  }
`;
PaymentBlock.Form.Apple.Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
PaymentBlock.Form.Apple.Right.Top = styled.div`
  margin-bottom: 15px;
`;
PaymentBlock.Form.Apple.Right.Bottom = styled.div`
  width: 152px;
  height: 45px;
  background: rgba(93, 181, 116, 0.2);
  border-radius: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    color: #5db574;
  }
`;
PaymentBlock.Form.Info = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 36px;
`;

PaymentBlock.Form.Info.Text = styled.div`
  text-align: left;
  margin-bottom: 28px;
  background: #f3f2ff;
  border-radius: 12px;
  padding: 12px;
  span {
    font-size: 14px;
    line-height: 18.2px;
  }
`;

PaymentBlock.Form.Info.Img = styled.div`
  //margin-bottom: 32px;
  display: flex;
  justify-content: space-around;
  background: ${whiteColor};
  padding-bottom: 32px;
  img {
    width: 132px;
    height: auto;
    margin: 0 auto;
  }
`;

PaymentBlock.Form.Info.Time = styled.div`
  margin-top: 26px;
  padding-top: 26px;
  padding-bottom: 26px;
  text-align: left;
  border-top: 1px solid #cac5c2;
  border-bottom: 1px solid #cac5c2;
  span {
    font-family: SF, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: ${blackColor};
    &.bold {
      font-weight: 600;
    }
  }
`;

PaymentBlock.Form.Info.Button = styled.div`
  margin-bottom: 30px;
`;

PaymentBlock.Select = styled.div`
  select {
    height: 59px;
    font-family: "SF", sans-serif;
    font-size: 18px;
    appearance: none;
    color: ${darkColor};
    font-weight: 700;
    margin-top: 5px;
    width: 100%;
    border-radius: 50px;
    padding: 0px 20px;
    border-color: transparent;
    background: #dcdcdc url(${arrowIcon}) no-repeat right 20px top 25px;
    outline: none;
  }
`;
// PaymentBlock.Form.Info = styled.div``;

const PaymentFormBlock = styled.div`
  #apple-pay-button {
    //display: none;
    background-color: black;
    background-image: -webkit-named-image(apple-pay-logo-white);
    background-size: 100% 100%;
    background-origin: content-box;
    background-repeat: no-repeat;
    width: 100%;
    height: 44px;
    padding: 10px 0;
    border-radius: 10px;
  }
  .paywall-first {
    ul {
      list-style: none;
      padding-left: 20px;
      margin-bottom: 26px;
    }
    ul li::before {
      content: "\\\\2022";
      color: ${orangeColor};
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1em;
    }
    li {
      color: ${purpleColor};
      text-align: left;
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: 500;
      font-family: SF, sans-serif;
    }
    &-top {
      margin-bottom: 40px;
      background: ${whiteColor};
      backdrop-filter: blur(200px);
      border: 1px solid #aba6d6;
      border-radius: 12px;
      padding: 35px 20px 10px 20px;
    }
    &-dr {
      display: flex;
      padding-top: 12px;
      &-left {
        margin-right: 13px;
      }
      &-right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-bottom: 1px solid #dddcee;
        padding-bottom: 17px;
      }
      &:last-child {
        .paywall-first-dr-right {
          border: none;
        }
      }
    }
    &-center {
      padding-bottom: 18px;
      border-bottom: 1px solid #cac5c2;
      margin-bottom: 20px;
    }
    &-total {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 18px;
      padding-bottom: 18px;
      //border-top: 1px solid #cac5c2;
      border-bottom: 1px solid #cac5c2;
    }
    &-between {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-text {
        display: flex;
        align-items: center;
        .decor {
          position: relative;
          color: #000;
          text-decoration: none;
          width: 80px;
        }
        .decor:before {
          border-bottom: 2px solid ${blackColor};
        }
      }
      &-banner {
        padding: 5px 5px;
        background: #5db574;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 80px;
      }
      &-paid {
        display: flex;
        padding-top: 35px;
        padding-bottom: 9px;
        border-bottom: 1px solid #cac5c2;
        border-top: 1px solid #cac5c2;
      }
    }
    &-rating {
      display: flex;
      flex-direction: column;
      background: ${whiteColor};
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
      border-radius: 12px;
      padding: 27px 32px 25px 32px;
      &-top {
        display: flex;
        align-items: center;
        margin-bottom: 41px;
        &-left {
          padding-right: 30px;
          border-right: 1px solid #c6c4df;
        }
        &-right {
          padding-left: 30px;
        }
      }
      &-count {
        display: flex;
      }
      &-bottom {
        display: flex;
        justify-content: space-between;
        &-item {
          &-top {
            width: 100px;
            background: rgba(5, 2, 55, 0.1);
            border-radius: 50px;
            padding-top: 6px;
            padding-bottom: 6px;
            margin-bottom: 6px;
          }
        }
      }
    }
  }
  .payment-block {
    &-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 31px;
    }
    &-cards {
      padding: 13px 28px;
      background: #dcdcdc;
      border-radius: 12px;
      margin-bottom: 18px;
      img {
        width: 100%;
      }
    }
    &-chose {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      &-item {
        position: relative;
        background: ${whiteColor};
        border-radius: 12px;
        border: 1px solid #c6c4df;
        transition: 0.1s;
        width: 48%;
        padding: 8px 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        flex-direction: column;
        &.active {
          background: #ffffff;
          border: 1px solid rgba(240, 119, 51, 0.5);
          box-shadow: 0px 4px 16px rgba(240, 119, 51, 0.25);
          border-radius: 12px;
        }
        &-top {
          margin-bottom: 6px;
        }
        &-bottom {
          img {
            max-width: 130px;
          }
        }
        &-paypal {
          img {
            width: 77px;
          }
        }
        &-warning {
          img {
            margin-right: 12px;
          }
        }
      }
    }
  }
`;

const CardInputWrapper = styled.div`
  background: ${(props) => (props.isValid ? whiteColor : whiteColor)};
  border-radius: 12px;
  padding: 17px 23px;
  height: 57px;
  border: ${(props) =>
    props.isValid ? "1px solid #a19fbf" : "1px solid #F02C2C"};
  width: 100%;
  box-sizing: border-box;
  transition: 0.3s;
  position: relative;
  input {
    background: ${(props) => (props.isValid ? whiteColor : whiteColor)};
    border-radius: 12px;
    border: none;
    width: 100%;
    box-sizing: border-box;
    transition: 0.3s;
    position: relative;
    font-weight: 700;
    height: 100%;
    font-family: SF, sans-serif;
    font-size: 16px;
    color: ${darkColor};
    :active,
    :hover,
    :focus {
      outline: 0;
      outline-offset: 0;
    }
    &:focus-visible {
      outline: none;
    }
    &::placeholder {
      font-family: SF, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 110%;
      color: #6c6c6c;
    }
  }
  &.cardnumber {
    padding-left: 50px;
  }
`;

CardInputWrapper.Paypal = styled(CardInputWrapper)`
  transition: 0.3s;
  border: ${(props) =>
    props.isValid ? "1px solid #D3D3D3" : "2px solid #CB6A4F"};
  border-radius: 3px;
`;

CardInputWrapper.Horizontal = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 17px;
`;

CardInputWrapper.Half = styled(CardInputWrapper)`
  width: 50%;
  position: relative;
  border-radius: 12px 0 0 12px;
  &:last-child {
    border-radius: 0 12px 12px 0;
    border-left: none;
  }
  input {
    background: ${(props) => (props.isValid ? "#DCDCDC" : "#FFE8E8")};
    border-radius: 12px 0 0 12px !important;
    padding: 17px 23px;
    border: none;
    width: 100%;
    box-sizing: border-box;
    transition: 0.3s;
    position: relative;
    font-weight: 700;
    font-family: SF, sans-serif;
    font-size: 16px;
    color: ${darkColor};
    :active,
    :hover,
    :focus {
      outline: 0;
      outline-offset: 0;
    }
    &:focus-visible {
      outline: none;
    }
    &::placeholder {
      font-family: SF, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 110%;
      color: #6c6c6c;
    }
  }
`;

CardInputWrapper.Message = styled.div`
  color: red;
  position: absolute;
  left: 2px;
  top: 56px;
  font-size: 12px;
  text-align: left;
`;

CardInputWrapper.Message.Paypal = styled(CardInputWrapper.Message)`
  color: #484343;
  position: absolute;
  height: 30px;
  width: 100%;
  background: #fdf6f7;
  border: 1px solid #d1a99b;
  border-radius: 4px;
  left: 0;
  top: 53px;
  font-size: 15px;
  text-align: left;
  box-sizing: border-box;
  padding-top: 5px;
  padding-left: 11px;
`;

CardInputWrapper.Message.Common = styled.div`
  color: red;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 5px;
  font-size: 12px;
  text-align: center;
`;

CardInputWrapper.Icon = styled.div`
  position: absolute;
  left: 17px;
  top: 18px;
  &.cvv {
    right: 15px;
    left: auto;
    top: 16px;
    width: 30px;
  }
`;
CardInputWrapper.Tooltip = styled.div`
  position: absolute;
  right: 0px;
  bottom: 75px;
  width: 190px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  box-sizing: border-box;
  text-align: left;
`;

CardInputWrapper.Tooltip.Arrow = styled.div`
  width: 50px;
  height: 50px;
  position: absolute;
  top: 100%;
  right: 0;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  overflow: hidden;
  &:after {
    content: "";
    position: absolute;
    width: 22px;
    height: 22px;
    background: #fff;
    -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    top: -5px;
    left: 50%;
    box-shadow: 0 4px 15px rgb(0 0 0 / 25%);
  }
`;

export {
  SubscriptionBlock,
  TimeBlock,
  PaymentBlock,
  CardInputWrapper,
  PaymentFormBlock,
};
